import React, { useState, useEffect } from 'react';
import Button from '../ui/Button';
import FormInput from '../ui/FormInput';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';
import { sendOtp, verifyOtp } from '../../services/api/implementation/impl';
import Cookies from 'js-cookie';
import socket from '../../../../socket';
import mixpanel from 'mixpanel-browser';
const LoginPhoneForm = () => {
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const { mutate: handleSendOtp, isLoading: isSendingOtp } = useMutation({
    mutationFn: async (payload) => await sendOtp(payload),
    onSuccess: async (res) => {
      toast.success('OTP sent successfully');
      setOtp('');
      setOtpSent(true);
      setIsProcessing(false);
    },
    onError: (err) => {
      console.error('Error sending OTP', err);
      toast.error('Error sending OTP');
      setIsProcessing(false);
    }
  });

  const { mutate: handleVerifyOtp, isLoading: isVerifyingOtp } = useMutation({
    mutationFn: async (payload) => await verifyOtp(payload),

    onSuccess: async (res) => {
      console.log({ res });
      const token = res.data.data.token;
      let userRole = res?.data?.data?.user?.role?.name;
      let userRoleId = res?.data?.data?.user?.role?.id;
      let userId = res?.data?.data?.user?.id;
      let userDesignation = res?.data?.data?.user?.designation?.name;
      let userVertical = res?.data?.data?.user?.vertical;
      let userDesignationLevel = res?.data?.data?.user?.level;

      Cookies.set('token', token);
      if (res.data.data.refreshToken) {
        Cookies.set('refreshToken', res.data.data.refreshToken);
      }
      Cookies.set('userRoleId', userRoleId);
      Cookies.set('userId', userId);
      Cookies.set('userDesignation', userDesignation);
      Cookies.set('userRole', userRole);
      Cookies.set('userVertical', userVertical);
      Cookies.set('userDesignationLevel', userDesignationLevel);

      toast.success('User successfully logged in');

      // Set Mixpanel user identity after successful login
      mixpanel.identify(userId); // Use a unique user ID
      mixpanel.people.set({
        $name: res?.data?.data?.user?.name,
        $phone: res?.data?.data?.user?.phone_number,
        $email: res?.data?.data?.user?.email,
        $vertical: res?.data?.data?.user?.vertical,
        $role: res?.data?.data?.user?.role?.name,
        $designation: res?.data?.data?.user?.designation?.name
      });

      // // Optional: Track the login event
      mixpanel.track('User Logged In', {
        'Login Method': 'Phone'
      });

      // Trigger custom login event for projects context
      window.dispatchEvent(
        new CustomEvent('userLoggedIn', {
          detail: {
            userId: userId,
            userRole: userRole,
            timestamp: new Date().toISOString()
          }
        })
      );

      // Navigate by role
      if (userRole === 'builder') {
        if (userVertical === 'Sales') {
          // if (userDesignationLevel === 'Low') {
          //   // navigate('/builder/sales');
          //   toast.error('You are not authorized to access this page');
          //   Cookies.remove('token');
          //   Cookies.remove('userRoleId');
          //   Cookies.remove('userId');
          //   Cookies.remove('userDesignation');
          //   Cookies.remove('userRole');
          //   Cookies.remove('userVertical');
          //   Cookies.remove('userDesignationLevel');
          //   return;
          // } else if (userDesignationLevel === 'Medium' || userDesignationLevel === 'High') {
          navigate('/builder/sales');
          // }
        } else if (userVertical === 'Operations') {
          if (userDesignationLevel === 'Low') {
            toast.error('You are not authorized to access this page');
            Cookies.remove('token');
            Cookies.remove('userRoleId');
            Cookies.remove('userId');
            Cookies.remove('userDesignation');
            Cookies.remove('userRole');
            Cookies.remove('userVertical');
            Cookies.remove('userDesignationLevel');
          } else if (userDesignationLevel === 'Medium' || userDesignationLevel === 'High') {
            navigate('/builder/dashboard');
          }
        } else if (userVertical === 'Accounts') {
          navigate('/builder/reports');
        } else if (userVertical === 'Inventory') {
          if (userDesignationLevel === 'Low') {
            toast.error('You are not authorized to access this page');
            Cookies.remove('token');
            Cookies.remove('userRoleId');
            Cookies.remove('userId');
            Cookies.remove('userDesignation');
            Cookies.remove('userRole');
            Cookies.remove('userVertical');
            Cookies.remove('userDesignationLevel');
          } else if (userDesignationLevel === 'Medium' || userDesignationLevel === 'High') {
            navigate('/builder/dashboard');
          }
        } else {
          navigate('/builder/dashboard');
        }
      } else if (userRole === 'admin') {
        navigate('/super-admin/home');
      }

      // Setup socket
      socket.auth.token = Cookies.get('token');
      socket.connect();
      socket.on('connect', () => {
        console.log('socket connected', socket.connected);
      });
      socket.on('connect_error', (err) => {
        console.error('Socket connection error:', err);
      });
      setIsProcessing(false);
    },
    onError: (err) => {
      console.error('Error verifying OTP', err);
      toast.error('Incorrect OTP');
      setIsProcessing(false);
    }
  });

  const handleSendOtpDummy = () => {
    if (phone === '7008574989') {
      toast.success('OTP sent successfully');
      setOtp('');
      setOtpSent(true);
    } else {
      toast.error('Invalid phone number');
    }
  };

  const handleVerifyOtpDummy = () => {
    if (otp === '4985') {
      const token = 'dummy_token'; // Dummy token
      Cookies.set('token', token);
      toast.success('User successfully logged in');
      navigate('/desired/path'); // Change this to your desired path
    } else {
      toast.error('Incorrect OTP');
    }
  };

  const onSubmitPhone = (data) => {
    if (!data.phone || data.phone.trim().length === 0 || data.phone.length !== 10) {
      toast.error('Please enter a valid phone number');
      return;
    }
    const payload = { phone: `+91${data.phone}` };
    handleSendOtp(payload);
    // Uncomment the next line to use dummy logic
    // handleSendOtpDummy();
  };

  const onSubmitOtp = (data) => {
    // Validate that OTP is not empty
    if (!data.otp || !data.otp.trim()) {
      toast.error('Please enter OTP');
      return;
    }

    const payload = { phone: `+91${phone}`, otp: data.otp.trim(), resend: false };
    handleVerifyOtp(payload);
    // Uncomment the next line to use dummy logic
    // handleVerifyOtpDummy();
  };

  /* 
    Handle phone field key down
  */
  const handlePhoneKeyDown = (e) => {
    if (e.key === 'Enter' && !isProcessing) {
      e.preventDefault();
      setIsProcessing(true);
      // Get phone value directly from DOM input to ensure we have the latest value
      const phoneInput = document.querySelector('input[name="phone"]');
      const phoneValue = phoneInput?.value?.trim() || '';

      // Trigger the send OTP functionality
      const payload = { phone: `+91${phoneValue}` };
      handleSendOtp(payload);
    }
  };

  /* 
    Handle OTP field key down
  */
  const handleOtpKeyDown = (e) => {
    if (e.key === 'Enter' && !isProcessing) {
      e.preventDefault();
      setIsProcessing(true);
      // Get OTP value directly from DOM input
      const otpInput = document.querySelector('input[name="otp"]');
      const otpValue = otpInput?.value?.trim() || '';

      // Validate that OTP is not empty
      if (!otpValue) {
        toast.error('Please enter OTP');
        setIsProcessing(false);
        return;
      }

      const payload = { phone: `+91${phone}`, otp: otpValue, resend: false };
      handleVerifyOtp(payload);
    }
  };

  /* 
    Handle autofill synchronization and keyboard events
  */
  useEffect(() => {
    const setupEventListeners = () => {
      const phoneInput = document.querySelector('input[name="phone"]');
      const otpInput = document.querySelector('input[name="otp"]');

      // Remove existing listeners first to prevent duplicates
      if (phoneInput) {
        phoneInput.removeEventListener('keydown', handlePhoneKeyDown);
        phoneInput.addEventListener('keydown', handlePhoneKeyDown);
      }

      if (otpInput) {
        otpInput.removeEventListener('keydown', handleOtpKeyDown);
        otpInput.addEventListener('keydown', handleOtpKeyDown);
      }
    };

    // Small delay to ensure DOM elements are ready
    const timeoutId = setTimeout(setupEventListeners, 100);

    // Cleanup function
    return () => {
      clearTimeout(timeoutId);
      const phoneInput = document.querySelector('input[name="phone"]');
      const otpInput = document.querySelector('input[name="otp"]');

      if (phoneInput) {
        phoneInput.removeEventListener('keydown', handlePhoneKeyDown);
      }
      if (otpInput) {
        otpInput.removeEventListener('keydown', handleOtpKeyDown);
      }
    };
  }, [otpSent]); // Only depend on otpSent, not phone

  return (
    <form className="flex flex-col gap-6 w-full h-full justify-center relative">
      <span className="text-stone-800 text-3xl font-semibold mb-24 absolute top-[7rem] left-0">
        Welcome back!
      </span>

      <div className="flex flex-col justify-between items-start gap-4">
        {!otpSent ? (
          <>
            <div className="flex items-center gap-2 relative w-full">
              <span className="p-1 px-2 absolute left-2 top-[52%] bg-gray-100 rounded-md text-sm text-gray-600">
                +91
              </span>
              <FormInput
                width={100}
                register={register}
                register_key={'phone'}
                label={'Phone Number'}
                type={'text'}
                isRequired={true}
                maxLength={10}
                onType={setPhone}
                CustomStyle={{ paddingLeft: '3.5rem' }}
              />
            </div>
            <div className="flex flex-row gap-2 items-center w-[100%] justify-center">
              <p
                className="text-[14px] font-semibold text-gray-600 cursor-pointer"
                onClick={() => navigate('/auth/login')}>
                Login via Email
              </p>
            </div>
            <Button
              type="submit"
              displayType="full-w-primary"
              width={100}
              onClick={handleSubmit(onSubmitPhone)}>
              Send OTP
            </Button>
          </>
        ) : (
          <>
            <FormInput
              width={100}
              register={register}
              register_key={'otp'}
              label={'OTP'}
              type={'text'}
              isRequired={true}
              onType={setOtp}
            />
            <Button
              type="submit"
              displayType="full-w-primary"
              width={100}
              onClick={handleSubmit(onSubmitOtp)}>
              Verify OTP
            </Button>
            <span
              className="text-primary cursor-pointer"
              onClick={() => handleSendOtp({ phone: `+91${phone}` })}>
              Resend OTP
            </span>
          </>
        )}
      </div>
    </form>
  );
};

export default LoginPhoneForm;
